// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/meditation-series`;
const categoryurl = `${process.env.REACT_APP_BASEURL}/api/admin/meditation-category`;

export const GetMeditationSeriesListApi = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getall"}),
    });
    // console.log("Response from API:", response);

    if (!response.ok) throw new Error("Failed to fetch meditation series list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const handleDeleteMeditationSeries = async (seriesId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this Series ?")) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete", data:{_id: seriesId} }),
      });

      const data = await response.json();
      if (data.success) toast.success("Series deleted successfully");
      else toast.warning("Series deleted, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};

export const submitMeditationSeriesApi = async (seriesData) => {
  const actionType = seriesData._id ? "edit" : "add";

  const payload = {
    action: actionType,
    data: {
      title: seriesData.title,
      description: seriesData.description,
      category: seriesData.category,
    },
  };

  if (seriesData._id) {
    payload.data._id = seriesData._id;
  }

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (result.success || response.status === 200 || response.status === 201) {
      toast.success(seriesData._id ? "Series updated successfully" : "Series added successfully");
      return result;
    } else {
      toast.error(result.message || "Failed to save Series");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the Series");
    return null;
  }
};
export const getMeditationSeriesByIdApi = async (id) => {
  try {
    const payload = {
      action: "getById",
      data: { _id: id }
    }
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    
    if (result.success) return result;
    else toast.error("Failed to load series");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
export const getMeditationCategories = async () => {
  try {
   
    const response = await fetch(categoryurl, {
      method: "Get",
      headers: { "Content-Type": "application/json" },
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load series");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
